import Icon from '../components/Icon.vue'

Icon.register({
  smoking: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M632 352H584C579.6 352 576 355.6 576 360V504C576 508.4 579.6 512 584 512H632C636.4 512 640 508.4 640 504V360C640 355.6 636.4 352 632 352zM553.3 87.1C547.6 83.3 544 77.1 544 70.3V8C544 3.6 540.4 0 536 0H488C483.6 0 480 3.6 480 8V70.3C480 92.3 490.2 113.7 508.6 125.7 550.8 153 576 199.5 576 249.7V280C576 284.4 579.6 288 584 288H632C636.4 288 640 284.4 640 280V249.7C640 184.2 607.6 123.5 553.3 87.1zM432 352H48C21.5 352 0 373.5 0 400V464C0 490.5 21.5 512 48 512H432C440.8 512 448 504.8 448 496V368C448 359.2 440.8 352 432 352zM400 464H224V400H400V464zM487.7 141.6C463.8 125 448 99.3 448 70.3V8C448 3.6 444.4 0 440 0H392C387.6 0 384 3.6 384 8V74.4C384 118.1 408.6 156 444.3 181.1 466.7 196.8 480 222.3 480 249.7V280C480 284.4 483.6 288 488 288H536C540.4 288 544 284.4 544 280V249.7C544 206.4 523 166.3 487.7 141.6zM536 352H488C483.6 352 480 355.6 480 360V504C480 508.4 483.6 512 488 512H536C540.4 512 544 508.4 544 504V360C544 355.6 540.4 352 536 352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/smoking.js
// module id = SKVe
// module chunks = 144